import { createActionCreators } from "../utils/actionCreators";

export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';

export const {
    request: loginRequest,
    success: loginSuccess,
    failure: loginFailure
} = createActionCreators('LOGIN');

export const {
    request: logoutRequest,
    success: logoutSuccess,
    failure: logoutFailure
} = createActionCreators('LOGOUT');

export const {
    request: checkJWTRequest,
    success: checkJWTSuccess,
    failure: checkJWTFailure
} = createActionCreators('CHECK_JWT');

export const {
    request: selectRoleRequest,
    success: selectRoleSuccess,
    failure: selectRoleFailure
} = createActionCreators('SELECT_ROLE');